// extracted by mini-css-extract-plugin
export default {"logoContainer":"profile-logo-module__logoContainer___b5lbO","logoImage":"profile-logo-module__logoImage___NOrkA","logoWrapper":"profile-logo-module__logoWrapper___dNWCf"};